// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__uwJ9T","icon":"Tooltip_icon__-ly3M","content":"Tooltip_content__V5Daa"};